import { render, staticRenderFns } from "./ShippingAddressPopup.vue?vue&type=template&id=bea2946c&scoped=true&"
import script from "./ShippingAddressPopup.vue?vue&type=script&lang=js&"
export * from "./ShippingAddressPopup.vue?vue&type=script&lang=js&"
import style0 from "./ShippingAddressPopup.vue?vue&type=style&index=0&id=bea2946c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea2946c",
  null
  
)

export default component.exports